import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawSluisVer3Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "sluis-ver-3";
		this.icon = svg_sluis_ver_3;
	}
}

window.customElements.define("inspx-draw-sluis-ver-3-module", DrawSluisVer3Module);

const svg_sluis_ver_3 = html`
<svg width="45" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
<g>
 <title>Layer 1</title>
 <rect stroke="#444444" id="svg_1" height="90" width="44.9502" y="0" x="0" fill="#ffffff"/>
 <line stroke="#444444" id="svg_3" y2="46.65161" x2="44.9502" y1="46.65161" x1="0.35596" fill="none"/>
 <text fill="#000000" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="39.24604" y="61.23444" id="svg_6" font-size="24" font-family="Sans-serif" text-anchor="middle" xml:space="preserve" transform="matrix(0.727236673471332,0,0,1.0685881825606462,-6.0327147962890315,-11.835305914722092) " stroke="#000000">sluis</text>
</g>
</svg>
`;
